<template>
<div class="chapter">
<div class="inner_page">
<div class="section" id="section006">
<div class="pseudo_margin_2"></div>
<div class="pseudo_margin_2"></div>
<div class="centered_text">
<p><span class="right_1" epub:type="pagebreak" id="page_ix" title="ix"><em>[T]he past is not closed, it receives meaning from our present actions.</em></span></p>
</div>
<div class="right_text">
<p><span class="smallcaps">CZESŁAW MIŁOSZ</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter02.vue?60a6c9cd